import { PostalCode, ZipCodeHit, LatLong, AlgoliaIndiceName } from '@packages/common';

import { SearchBase } from './searchBase';

export type ZipCodeSearchParam = PostalCode | LatLong;

export const zipCodeSearch =
  (searchBase: SearchBase) =>
  (searchParam: ZipCodeSearchParam, hitsPerPage = 1) => {
    if (typeof searchParam === 'string') {
      // Postal code checking, like check that 12345 is valid zip code in algolia
      return searchBase<ZipCodeHit>(AlgoliaIndiceName.ZIP_CODES, {
        query: '',
        // zip codes may contain spaces. For example for NL. algolia expects
        // filters that contain spaces to be surrounded by double quotes
        filters: `zip:"${searchParam}"`,
        offset: 0,
        length: 1,
        attributesToHighlight: [],
      });
    } else {
      // Search zip codes around geographical location
      return searchBase<ZipCodeHit>(AlgoliaIndiceName.ZIP_CODES, {
        query: '',
        aroundLatLng: `${searchParam.lat},${searchParam.lng}`,
        hitsPerPage,
      });
    }
  };
